// Camera state belongs to the map, independently of weather layers and time.
const modes = new WeakMap();
export const MAX_PITCH = 65;
export const CAMERA_STORAGE_KEY = 'wsv2-camera';
export const clampPitch = value => Math.max(0, Math.min(MAX_PITCH, Number(value) || 0));
export function normalizeBearing(value) {
    const n = Number(value); return Number.isFinite(n) ? ((n + 180) % 360 + 360) % 360 - 180 : 0;
}
export function readCameraState(query, saved = null) {
    const dim = String(query.get('dim') || query.get('dimension') || '').toLowerCase();
    const hasPitch = query.has('pitch') && query.get('pitch').trim() !== '' && Number.isFinite(Number(query.get('pitch')));
    const explicit = ['2d', '3d'].includes(dim) || hasPitch;
    const stored = !query.toString() && saved && typeof saved === 'object' ? saved : {};
    const mode = ['2d', '3d'].includes(dim) ? dim : hasPitch ? (Number(query.get('pitch')) > 0 ? '3d' : '2d') : stored.mode === '3d' ? '3d' : '2d';
    return {mode, pitch: mode === '3d' ? clampPitch(hasPitch ? query.get('pitch') : stored.pitch ?? 48) : 0,
        bearing: mode === '3d' ? normalizeBearing(query.get('bearing') ?? stored.bearing ?? -12) : 0, explicit};
}
export function setCameraMode(map, mode) { modes.set(map, mode === '3d' ? '3d' : '2d'); }
export function is3DView(map) { return modes.get(map) === '3d'; }
export function cameraSnapshot(map) {
    return {mode: is3DView(map) ? '3d' : '2d', pitch: is3DView(map) ? clampPitch(map.getPitch()) : 0,
        bearing: is3DView(map) ? normalizeBearing(map.getBearing()) : 0};
}
export function applyCameraState(map, camera, options = {}) {
    const controller = mapViewControllers.get(map);
    if (controller) controller.setMode(camera.mode || (camera.pitch > 0 ? '3d' : '2d'), {...options, camera});
}
const mapViewControllers = new WeakMap();
export function attachCameraController(map, controller) { mapViewControllers.set(map, controller); }
export function appendCameraToUrl(url, map) {
    const camera = cameraSnapshot(map);url.searchParams.set('dim', camera.mode);
    if (camera.mode === '3d') {url.searchParams.set('pitch', camera.pitch.toFixed(1));url.searchParams.set('bearing', camera.bearing.toFixed(1));}
    else {url.searchParams.delete('pitch');url.searchParams.delete('bearing');}
    return url;
}

// Old Earth share links survive the redirect; the native Maps query remains authoritative.
export function mergeLegacyEarthQuery(query, hash = '') {
    const result = new URLSearchParams(query);
    const legacy = new URLSearchParams(hash.replace(/^#/, ''));
    const raw = (legacy.get('v') || '').split(',');
    const camera = raw.map(Number);
    if (raw.length !== 5 || raw.some(v => !v.trim()) || camera.some(v => !Number.isFinite(v)) || Math.abs(camera[0]) > 180 || Math.abs(camera[1]) > 90) return result;
    const keys = ['lon', 'lat', 'zoom', 'bearing', 'pitch'];
    keys.forEach((key, i) => {if (!result.has(key) && !(key === 'lon' && result.has('lng'))) result.set(key, String(camera[i]));});
    if (!result.has('layers') && legacy.has('l')) result.set('layers', legacy.get('l').split('.').filter(Boolean).join(','));
    return result;
}
